import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-period-earning',
  templateUrl: './select-period-earning.component.html',
  styleUrls: ['./select-period-earning.component.scss']
})
export class SelectPeriodEarningComponent implements  OnDestroy {

  public items: any[] = [
    { value: 1, name: 'Prom. día' },
    { value: 2, name: 'Tendencia' }
  ];

  public periodEarning: any = [];
  public ngxDisabled = false;
  periodEarning$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.periodEarning$ = this.sharedService.sharedPeriodEarning.subscribe(periodEarning => {
      this.periodEarning = periodEarning;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.periodEarning$.unsubscribe();
  }

  changeVariable(event: any) {
    this.periodEarning = event;
    this.sharedService.nextPeriodEarning = this.periodEarning;
  }
}
